import React, {useState} from 'react'
import {Form, Input, InputNumber, message, Modal, Select, Space, Spin, Tag} from "antd"
import {decWallet, getWalletList} from "../../../../../api/clubMemberList"
import {useClubMemberContext} from "../../../store/useClubMemberContext"

const ClubMemberEditWallet = ({memberId}) => {
    const [walletOptions, setWalletOptions] = useState([])
    const [form] = Form.useForm()
    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const {fetchClubMemberList} = useClubMemberContext()

    const fetchWalletList = async () => {
        setIsLoading(true)
        await getWalletList(memberId).then((res) => {
            if (res.list) {
                const options = res.list.map(item => {
                    return {
                        label: (<Space direction={"horizontal"}>
                            <span> {item.name}</span>
                            <Tag color={"gold"}>{'余额：' + (item.balance / 100).toFixed(2) + '元'}</Tag>
                        </Space>),
                        value: item.id
                    }
                })
                setWalletOptions(options)
                form.setFieldValue('walletId', options[0].value)
                return
            }
            message.error(`获取钱包列表失败：${res.detail}`)
        }).catch(err => {
            message.error(`获取钱包列表失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const fetchDecWallet = async (values) => {
        const {walletId, decAmount, reason} = values
        const decAmountInt = (decAmount * 100).toFixed(2)
        setIsLoading(true)
        await decWallet(memberId, walletId, decAmountInt, reason).then((res) => {
            if (res.status) {
                message.success('修改成功')
                setIsShow(false)
                fetchClubMemberList()
                form.resetFields()
                return
            }
            message.error(`修改失败：${res.detail}`)
        }).catch(err => {
            message.error(`修改失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const handleClick = async () => {
        setIsShow(true)
        await fetchWalletList()
    }

    const handleOk = async (values) => {
        await fetchDecWallet(values)
    }

    const handleCancel = () => {
        setIsShow(false)
        form.resetFields()
    }

    const items = [
        {
            label: '钱包列表',
            name: 'walletId',
            children: (<Select
                style={{width: '100%'}}
                placeholder={"请选择钱包"}
                options={walletOptions}
            >
            </Select>),
            rules: [
                {required: true, message: '请选择钱包'}
            ]
        },
        {
            label: '扣减金额',
            name: 'decAmount',
            children: (
                <InputNumber
                    style={{width: '100%'}}
                    placeholder={"请输入扣减金额"}
                />
            ),
            rules: [
                {required: true, message: '请输入扣减金额'}
            ]
        },
        {
            label: '说明',
            name: 'reason',
            children: (
                <Input placeholder={"请输入说明"}/>
            ),
            rules: [
                {required: true, message: '请输入说明'}
            ]
        }
    ]


    return (
        <div>
            <div onClick={handleClick}>修改钱包</div>
            <Modal
                open={isShow}
                onCancel={handleCancel}
                onOk={form.submit}
                confirmLoading={isLoading}
                title={"修改钱包"}
                destroyOnClose
            >
                <Spin spinning={isLoading}>
                    <Form
                        style={{padding: 16}}
                        labelCol={{span: 6}}
                        wrapperCol={{span: 18}}
                        form={form}
                        onFinish={handleOk}
                    >
                        {items.map(item => {
                            return (<Form.Item label={item.label} name={item.name} key={item.name}
                                               rules={item.rules}>
                                {item.children}
                            </Form.Item>)
                        })}
                    </Form>
                </Spin>
            </Modal>
        </div>
    )
}

export default ClubMemberEditWallet


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberEdit/component/ClubMemberEditWallet.js